/**
 * A barra de cima dos miolos, com o monograma e o wordmark.
 *
 * Papel: reproduz a `.topbar` das duas origens — fundo branco, 58 px, borda de
 * baixo na cor do tema, monograma de 40 px com raio de 3 px, filete de 1×28 px e
 * wordmark de 24 px (Finanças l. 27–33 e 299–305; Manutenções l. 43–76 e
 * 483–489).
 *
 * Como usar: quem monta é o `QuadroEmbutido`. O recuo e a sombra mudam por tema
 * porque a origem de Finanças recua 32 px à esquerda e tem sombra, e a de
 * Manutenções recua 20 px dos dois lados e não tem. Os dois arquivos de imagem
 * foram extraídos do HTML de Finanças, byte a byte, e não são os de
 * `villa-prado-logotipo.png` e `villa-prado-monograma.png`, que têm as mesmas
 * dimensões e outro conteúdo. A barra some na impressão; cada tela que imprime
 * desenha o próprio cabeçalho de impressão.
 */
import { cn } from '@/shared/lib/utils';
import { type TemaEmbutido } from './tema-embutido';

/** Monograma da origem, extraído de `controle-financeiro-villa-prado.html` l. 301. */
const MONOGRAMA = '/marca/villa-prado-monograma-origem.jpg';

/** Wordmark da origem, extraído de `controle-financeiro-villa-prado.html` l. 303. */
const WORDMARK = '/marca/villa-prado-wordmark-origem.png';

/** O recuo e a sombra de cada origem. */
const ESTILO_POR_TEMA: Readonly<Record<TemaEmbutido, string>> = {
  financeiro: 'pr-5 pl-8 shadow-emb-barra',
  manutencoes: 'flex-wrap justify-between px-5',
};

/**
 * A barra com os logotipos.
 *
 * @param tema - Qual origem a barra reproduz.
 * @returns A barra.
 */
export function BarraDoApp({ tema }: { tema: TemaEmbutido }) {
  return (
    <div
      className={cn(
        'flex h-[58px] items-center gap-2.5 border-b border-emb-borda bg-superficie print:hidden',
        ESTILO_POR_TEMA[tema],
      )}
    >
      <div className={cn('flex items-center gap-3', tema === 'financeiro' && 'mr-2')}>
        <img
          src={MONOGRAMA}
          alt="Villa Prado"
          className="h-10 w-auto shrink-0 rounded-[3px]"
        />
        <div aria-hidden="true" className="h-7 w-px shrink-0 bg-emb-borda" />
        <img src={WORDMARK} alt="Villa Prado" className="h-6 w-auto object-contain" />
      </div>
    </div>
  );
}
